import React, { Component } from 'react'
import PropTypes from 'prop-types'
import KeyTakeaway from '../../../components/business/creport/keyTakeaway'
import ReportFiles from '../../../components/business/creport/files'

class PhysicalTestPreview extends Component {
  static propTypes = {
    report: PropTypes.object,
    dealHtml: PropTypes.func
  }

  render() {
    const { report, dealHtml } = this.props
    return (
      <div className="report-physical report-section">
        <h1 className="section-title">4. PHYSICAL TESTS</h1>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.physical_intro)
          }}
        />
        <h3 className="section-sub-title">Summary</h3>
        <p
          className="text-section"
          dangerouslySetInnerHTML={{
            __html: dealHtml(report.physical_summary)
          }}
        />
        {/* tests placeholder */}
        <h3 className="section-sub-title">Key Takeaway</h3>
        {report.physical_takeaway && (
          <KeyTakeaway initialValue={report.physical_takeaway} />
        )}
        {(report.physical_media_files || report.physical_media_intro) && (
          <ReportFiles
            readOnly={true}
            files={report.physical_media_files || []}
            introduction={report.physical_media_intro}
          />
        )}
      </div>
    )
  }
}

export default PhysicalTestPreview
